/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Session_ExpiredInputs */

const en_mobile_session_expired = /** @type {(inputs: Mobile_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, your session has expired. Please sign in again.`)
};

const es_mobile_session_expired = /** @type {(inputs: Mobile_Session_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo sentimos, tu sesión ha expirado. Inicia sesión de nuevo.`)
};

/**
* | output |
* | --- |
* | "Sorry, your session has expired. Please sign in again." |
*
* @param {Mobile_Session_ExpiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_session_expired = /** @type {((inputs?: Mobile_Session_ExpiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Session_ExpiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_session_expired(inputs)
	return en_mobile_session_expired(inputs)
});